const HighlightsData = [
    {
        id: 1,
        detail: "Prime Location: Situated in the heart of Gurgaon’s prestigious DLF Phase V on Golf Course Road, offering easy access to business districts and lifestyle hubs.",
    },
    {
        id: 2,
        detail: "Luxurious Apartments: Spacious 3, 4, and 5 BHK residences with elegant layouts, premium finishes, and breathtaking views of the Aravalli hills and city skyline.",
    },
    {
        id: 3,
        detail: "World-Class Amenities: Clubhouse, swimming pool, wellness center, landscaped gardens, sports facilities, and dedicated leisure spaces for relaxation and recreation.",
    },
    {
        id: 4,
        detail: "Excellent Connectivity: Seamless access to NH-8, Rapid Metro, and proximity to top schools, healthcare centers, malls, and entertainment zones.",
    },
    {
        id: 5,
        detail: "Advanced Security: Round-the-clock security with CCTV surveillance, gated access, trained personnel, and ample parking facilities for residents and visitors.",
    },
    {
        id: 6,
        detail: "Refined Lifestyle: Thoughtfully designed services and conveniences that elevate everyday living into a luxurious and fulfilling experience.",
    },
]

export default HighlightsData;